module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAhCAMAAABgOjJdAAAAQlBMVEVMaXHVKx7VKx7VKx7VKx7VKx7VKx7VKx7VKx7VKx7VKx7VKx7VKx7VKx7VKx7////VKx7gYFbqlY/YOCzaRjrniIGqblUBAAAAD3RSTlMA0ODAMPCgEGBAgCCwkFCXlcgLAAAACXBIWXMAAAsSAAALEgHS3X78AAAA30lEQVQ4jaWUSRaEIAxEC1QGhxbUvv9V+xmQx+yiaxfzgQQqIpXUWmuJhqRaJ0Pi4lNB5OzTHlI5oHmcv8XGBJjz/K14G1EDYiTscB2kAtHhi91JIZ5cLZI3CTPkVRaEO2fqEQzAx/QIM6adVogZoDovS/o6wgX29LUSeewVWWoY4wth/HX9RyyvxFulHGD9+1iBrU8o+HabxG181iME0qcriYUMMrSJzblwCQ7JCfaMXzDq6R71Cb1Nb6m4+qAIAMZkJP0R6dDJYqi24heg1zgvXJv5+CtBjQ9CPesB/ABV/DKC8Kd63wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/sui.png
// module id = X6Vx
// module chunks = 0